import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { OrderFilterValuesLoadGuard } from 'app/core/guards/order-filter-values-load.guard';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Observable, of } from 'rxjs';
import * as fromRoot from '..';
import { OrderDetailOpenAction } from './order-detail.actions';
import { EditOrderDetail } from './order-detail.interface';
import { logger } from 'app/core/util/logger';
import { goAction } from '../router/router.actions';
import { filter, first, map, switchMap } from 'rxjs/operators';

/**
 * Guard to async load an order before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetOrderGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug(`In GetOrderGuard`);

    // return this.store.pipe(first(),map(state => state.customerInfo.authorization.ORDER.GET),switchMap(canOpenOrder => {
    return this.store.pipe(
      first(),
      switchMap(state => {
        if (!state.session.authorization.data.ORDER.GET) {
          this.store.dispatch(goAction({ path: '/' }));
          return of(false);
        }

        // cr127: if multiple customer query, the selected customerId in header may not be the owner of the order, then this customerIds array will be used
        const customerIds = state.session.userContext.isSuperUser ? state.session.customerPermissions.data.queryOrGetOrder.map(c => c.id) : [];
        const salesOrderNumber = route.queryParamMap.get('salesOrderNumber');
        this.store.dispatch(
          new OrderDetailOpenAction({
            salesOrderNumber: salesOrderNumber !== 'null' && salesOrderNumber !== 'undefined' ? salesOrderNumber : null,
            etmOrderNumber: route.paramMap.get('etmOrderNumber'),
            customerIds,
          })
        );
        return this.store.select('editOrderDetail').pipe(
          filter((editOrderDetail: EditOrderDetail) => !editOrderDetail.mode.loading),
          first(),
          map((editOrderDetail: EditOrderDetail) => editOrderDetail.mode.loadSuccess)
        );
      })
    );
  }

  getDependencies(): any {
    return [OrderFilterValuesLoadGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'ORDER.GET',
    };
  }
}
